import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { AvanoUnsavedChangesService, GenericUnsavedChangesContext } from '@avano/avano-components/avano-unsaved-changes';
import { Observable, of } from 'rxjs';
import { ProductsService } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class UnsavedTabsGuard implements CanDeactivate<unknown> {
  constructor(private unsavedChangesService: AvanoUnsavedChangesService, private productsService: ProductsService) {}

  canDeactivate(_: unknown, currentRoute: ActivatedRouteSnapshot, __: RouterStateSnapshot, nextState: RouterStateSnapshot): Observable<boolean> {
    if (currentRoute.queryParamMap.has('productId')) {
      const currentTabIds = currentRoute.queryParamMap.getAll('productId');
      const nextTabIds = nextState.root.queryParamMap.getAll('productId');
      const difference = currentTabIds.filter((id) => !nextTabIds.includes(id)).map((id) => id);
      const changedTabs = this.productsService.getChangedTabIds();
      const isUnsaved = changedTabs.some((tabId) => difference.includes(tabId));
      if (changedTabs.length > 0 && isUnsaved) {
        return this.unsavedChangesService.promptDirtyComponentsActions([GenericUnsavedChangesContext]);
      } else {
        return of(true);
      }
    }
    return of(true);
  }
}
